<template>
    <div class="content-wrap">
        <div class="result-tab-wrap">
            <div :class="['result-tab-item', curTab === index && 'result-tab-item-act']" v-for="(item, index) in tabList" :key="index" @click="changeTab(index)">{{ item.name }}</div>
        </div>
        <div class="result-content">
            <transition name="fade-transform" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            curTab: 0,
            sPhone: "",
            tabList: [
                { name: "用户旅程", path: "/performance/user/journey" },
                { name: "用户画像", path: "/performance/user/portrait" },
                { name: "客户上线", path: "/performance/user/customer" },
            ],
        };
    },
    created() {
        let sPath = this.$route.path;
        this.tabList.forEach((item, index) => {
            if (item.path == sPath) {
                this.curTab = index;
            }
        });
        this.tabList.indexOf(sPath);
    },
    methods: {
        // tab切换
        changeTab(index) {
            this.curTab = index;
            this.$router.replace({ path: this.tabList[index].path });
        },
    },
};
</script>

<style lang="scss" scoped>
.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 0.4s;
}
.fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
}
.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
.content-wrap {
    position: relative;
}
.result-tab-wrap {
    width: 100%;
    padding: 26px 24px;
    box-sizing: border-box;
    border-top: 1px solid #f7f7f7;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    background: #fff;

    .result-tab-item {
        width: 31%;
        height: 64px;
        border-radius: 8px;
        border: 2px solid $deepGreen;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: $deepGreen;
        line-height: 64px;
        text-align: center;
    }

    .result-tab-item-act {
        background: $deepGreen;
        color: #ffffff;
        border: none;
    }
}
</style>